export function getConvexUrl(): string {
  const configured = (import.meta.env.VITE_CONVEX_URL as string | undefined)?.trim();

  if (!configured) {
    throw new Error('VITE_CONVEX_URL nije postavljen.');
  }

  const parsed = new URL(configured);
  if (parsed.protocol !== 'https:') {
    throw new Error('VITE_CONVEX_URL mora koristiti HTTPS.');
  }

  return configured;
}
